/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { catchError } from 'rxjs/operators';
import { NavigatorService } from '@services/navigator/navigator.service';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { Observable, of } from 'rxjs';
import { ERRORS } from '@models/app/errors';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private navigator: NavigatorService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.isSessionSet()) {
      return true;
    }

    return this.authService
      .startSession()
      .pipe(catchError(() => this.handleError()));
  }

  /**
   * gestisco l'eventuale errore navigando verso pagina di errore
   */
  private handleError(): Observable<UrlTree> {
    return of(this.navigator.getErrorPageUrl(ERRORS.unauthorized));
  }
}
